/**
 * PixUpPlay RGS Provider Configuration
 * Provider-specific win thresholds, types, symbol mappings, and settings
 */

export const PROVIDER_CONFIG = {
  // Provider identification
  PROVIDER_NAME: "PixUpPlay",
  GAME_NAME: "noble-fruits",

  /**
   * Symbol ID mapping for PixUpPlay RGS
   *
   * PixUpPlay API uses string identifiers for symbols (e.g., "W", "H1", "N1"),
   * while the game internally uses numeric IDs (0-10).
   *
   * Noble Fruits symbol mapping:
   * - Wild: "W" → 0
   * - High: "H1" → 1
   * - Mid: "H2"-"H3" → 2-3
   * - Low: "H4", "N1"-"N4" → 4-8
   * - Scatter: "F1" → 9, "F2" → 10
   */
  SYMBOL_MAP: {
    W: 0, // Wild (w1)
    H1: 1, // High 1 (h1)
    H2: 2, // Mid 1 (m1)
    H3: 3, // Mid 2 (m2)
    H4: 4, // Low 1 (l1)
    N1: 5, // Low 2 (l2)
    N2: 6, // Low 3 (l3)
    N3: 7, // Low 4 (l4)
    N4: 8, // Low 5 (l5)
    F1: 9, // Scatter 1 (sc1)
    F2: 10, // Scatter 2 (sc2)
  },

  // Default slotface symbol IDs: one per reel, no winning combos
  DEFAULT_SLOTFACE_SYMBOL_IDS: [4, 5, 6, 7],

  // Win thresholds (multiplier of bet size) — only animated win tiers
  WIN_THRESHOLDS: {
    BIG_WIN_THRESHOLD: 15, // 15x - 29.99x
    SUPER_WIN_THRESHOLD: 30, // 30x - 49.99x
    MEGA_WIN_THRESHOLD: 50, // 50x - 99.99x
    EPIC_WIN_THRESHOLD: 100, // 100x - 4999.99x
    MAX_WIN_THRESHOLD: 5000, // 5000x+ (max win cap)
  },

  // Max win multiplier (bet × this value = max possible win)
  MAX_WIN_MULTIPLIER: 5000,

  // Win type constants
  WIN_TYPES: {
    REGULAR_WIN: "regular_win",
    BIG_WIN: "big_win",
    SUPER_WIN: "super_win",
    MEGA_WIN: "mega_win",
    EPIC_WIN: "epic_win",
    MAX_WIN: "max_win",
  },

  // Which wins trigger animated celebrations (full-screen win animation)
  ANIMATED_WIN_TYPES: [
    "big_win",
    "mega_win",
    "super_win",
    "epic_win",
    "max_win",
  ],

  // Error code mappings - Maps PixUpPlay error codes to universal error codes
  ERROR_CODES: {
    INSUFFICIENT_BALANCE: 301,
    INSUFFICIENT_FUNDS: 301,
    INVALID_SESSION: 401,
    SESSION_EXPIRED: 401,
    INVALID_TOKEN: 401,
    GAME_UNAVAILABLE: 500,
    MAINTENANCE: 503,
    INVALID_BET: 400,
  },
};
